var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features-list"},_vm._l((_vm.features.filter(function (feature) {
      return feature.group && _vm.featureGroupIds.includes(feature.group._id)
      })),function(feature){return _c('feature',{key:feature._id,attrs:{"field":_vm.field,"feature":feature},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }